'use es6';

export default function (onOpenStart, onOpenComplete, onCloseStart, onCloseComplete) {
  return {
    onOpenStart,
    onOpenComplete,
    onCloseStart,
    onCloseComplete
  };
}